import { StoreWithApi } from 'quil';
import { DataManagementApi } from './api/DataManagementApi';
import apiTemp from './api/AnalysisAppApi';
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

const pca = new PublicClientApplication(msalConfig);
const activeAccount = pca.getActiveAccount();
const userId = activeAccount?.homeAccountId;

const {store, persistor} = StoreWithApi(DataManagementApi, apiTemp, userId);

export default {store, persistor};

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
